import React, { useRef, useState } from 'react';
import { linkedInComposerUrl } from '../utils/profileSharing';

const buttonStyle = {
  display: 'inline-flex', alignItems: 'center', padding: '9px 18px',
  borderRadius: 999, border: '1.5px solid #e8e5e0', fontSize: 13,
  fontWeight: 600, color: '#444', background: '#fff', cursor: 'pointer',
  textDecoration: 'none', fontFamily: 'inherit',
};

export default function LinkedInShare({ profileUrl, postText, defaultOpen = false, onCopy }) {
  const [open, setOpen] = useState(defaultOpen);
  const [status, setStatus] = useState('');
  const textRef = useRef(null);
  const text = postText || profileUrl;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setStatus(postText ? 'Post copied. Open LinkedIn, paste it into a post, then publish.' : 'Profile link copied. Open LinkedIn and paste it into a post if it is not attached.');
      if (onCopy) onCopy();
    } catch (_) {
      textRef.current?.focus();
      textRef.current?.select();
      setStatus('Automatic copying is unavailable. Copy the selected text below, then paste it into your LinkedIn post.');
    }
  };

  if (!profileUrl) return null;

  return (
    <div style={{ maxWidth: 600, width: open ? '100%' : undefined }}>
      {!defaultOpen && (
        <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} style={buttonStyle}>
          Share on LinkedIn
        </button>
      )}
      {open && (
        <div style={{ padding: 18, marginTop: defaultOpen ? 0 : 12, border: '1px solid #e8e5e0', borderRadius: 12, background: '#f9f9f7' }}>
          <p style={{ margin: '0 0 12px', color: '#415347', fontSize: 13, lineHeight: 1.6 }}>
            Copy {postText ? 'this post' : 'the profile link'}, then open LinkedIn. If LinkedIn opens without the profile attached, choose “Start a post” and paste it.
            {' '}Review your post and publish it there—opening LinkedIn does not publish automatically.
          </p>
          <textarea
            ref={textRef}
            aria-label={postText ? 'LinkedIn post with profile link' : 'Public profile link for LinkedIn'}
            readOnly value={text} rows={postText ? 8 : 2}
            onFocus={event => event.target.select()}
            style={{ boxSizing: 'border-box', width: '100%', padding: 12, border: '1px solid #ddd', borderRadius: 8, color: '#0a1a0f', background: '#fff', font: '13px/1.6 sans-serif', resize: 'vertical', marginBottom: 12 }}
          />
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
            <button type="button" onClick={copy} style={{ ...buttonStyle, background: '#004D35', color: '#fff' }}>
              {postText ? 'Copy post' : 'Copy profile link'}
            </button>
            <a href={linkedInComposerUrl(profileUrl)} target="_blank" rel="noopener noreferrer" style={buttonStyle}>
              Open LinkedIn composer
            </a>
          </div>
          <p role="status" style={{ color: '#004D35', fontSize: 13, lineHeight: 1.6, margin: status ? '12px 0 0' : 0 }}>{status}</p>
        </div>
      )}
    </div>
  );
}
